<div class="add-background">
    <div class="container">

        <div class="row">
            <div class="col-6">
                <a class="logo" href="https://www.payhoa.com"><img alt=""
                                                                   src="/assets/images/payhoa/marketing/logo.svg"/></a>
            </div>
            <div class="col-6">
                <div class="text-right alt-text">Don't have an account?
                    <span [routerLink]="['/auth/join']" class="add-hover">Join your HOA.</span>
                </div>
            </div>
        </div>

        <h3 class="text-center semibold">Sign in to your account</h3>

        <div class="row">
            <div class="col-md-6 offset-md-3 col-12">
                <div class="card">
                    <div class="card-body">
                        <!-- this shows if they are forwarding -->
                        <div *ngIf="isForwarding" class="p-4 text-center">
                            <h3>Already logged in</h3>
                            <span>Redirecting you...</span>
                        </div>

                        <!-- this shows if they are not forwarding -->
                        <form (keydown)="submitByEnter($event)"
                              *ngIf="isActive && !isForwarding"
                              [formGroup]="model" novalidate>
                            <div class="form-group">
                                <label class="for-input">Email</label>

                                <input #emailInput (focus)="true"
                                       [errorClassWhenInvalid]="model.controls['email']"
                                       [readonly]="isSubmitting"
                                       aria-describedby="email-address"
                                       autofocus
                                       class="form-control"
                                       formControlName="email"
                                       placeholder="name@example.com"
                                       required
                                       name="email"
                                       tabindex="1" type="email" validateEmail/>
                                <lf-control-messages [control]="model.controls['email']"></lf-control-messages>
                            </div>

                            <div>
                                <small [routerLink]="['/auth/password/request-reset-email']" class="float-right text-secondary semibold add-hover"
                                       tabindex="4        ">
                                    Forgot your password?
                                </small>

                                <label class="for-input last">Password</label>
                                <input [errorClassWhenInvalid]="model.controls['password']"
                                       [readonly]="isSubmitting"
                                       aria-describedby="password"
                                       class="form-control"
                                       formControlName="password"
                                       minlength="6"
                                       placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
                                       required
                                       name="password"
                                       tabindex="2" type="password"/>
                                <lf-control-messages [control]="model.controls['password']"></lf-control-messages>
                            </div>
                        </form>
                    </div>
                    <button (click)="onSubmit()" *ngIf="!isForwarding"
                            [class.disabled]="isSubmitting"
                            [disabled]="isSubmitting"
                            class="card-footer bg-primary text-white text-center add-hover semibold"
                            tabindex="3">
                        {{isSubmitting ? 'Logging in...' : 'Login'}}
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>

